export default {
  bind(el, binding) {
    el._hoverClass = binding.value || ' hover'
    el._mouseoverListener = _ => {
      el.className += el._hoverClass
      el._hover = true
    }

    el._mouseoutListener = _ => {
      el.className = el.className.replace(el._hoverClass, '')
      el._hover = false
    }

    el.addEventListener('mouseover', el._mouseoverListener)
    el.addEventListener('mouseout', el._mouseoutListener)
  },
  componentUpdated(el) {
    if (el._hover) {
      el.className += el._hoverClass
    }
  },
  unbind(el, binding) {
    el.removeEventListener('mouseover', el._mouseoverListener)
    el.removeEventListener('mouseout', el._mouseoutListener)
  }
}
